module.exports = __webpack_public_path__ + "static/media/light-motion-orbit-phasing.3bd7042.mp4";